import {Injectable, OnDestroy} from '@angular/core';
import {AbstractFindAllService} from '../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {InsolesModel} from '../../api/model/insoles.model';
import {InsolesSummaryModel} from '../../api/model/insolesSummary.model';
import {InsolesRepository} from './ngrx/insoles.repository';
import {InsolesSummaryDataServiceAdapter} from './ngrx/insolesSummary.data.service.adapter';

@Injectable()
export class InsolesSummaryFindAllService extends AbstractFindAllService<InsolesModel, InsolesSummaryModel>
    implements OnDestroy{

    constructor(repository: InsolesRepository, dataServiceAdapter: InsolesSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
